import React, { useEffect } from "react";
import { FaWhatsapp } from "react-icons/fa";
import Header from "../layout/Header";
import "aos/dist/aos.css";
import "../../styles/index.css";
const Footer = React.lazy(
  () =>
    new Promise((resolve) => {
      setTimeout(() => resolve(import("../layout/Footer/index")), 1000);
    })
);
const Layout = ({ children }) => {
  useEffect(() => {
    /**
     * Server-side rendering does not provide the 'document' object
     * therefore this import is required either in useEffect or componentDidMount as they
     * are exclusively executed on a client
     */
    // console.log("Width: ", window.innerWidth, document.documentElement.clientWidth, window.innerWidth < 768)
    const AOS = require("aos");
    AOS.init({
      useClassNames: true,
      initClassName: true,
      animatedClassName: "animated",
      // Global settings:
      disable: document.documentElement.clientWidth <= 991, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function

      // startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
      // initClassName: 'aos-init', // class applied after initialization
      // animatedClassName: 'aos-animate', // class applied on animation
      // useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
      // disableMutationObserver: false, // disables automatic mutations' detections (advanced)
      // debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
      // throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

      // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
      offset: 120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 1500, // values from 0 to 3000, with step 50ms
      // easing: 'ease', // default easing for AOS animations
      once: true, // whether animation should happen only once - while scrolling down
      // mirror: false, // whether elements should animate out while scrolling past them
      // anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
    });
  }, []);

  return (
    <React.Fragment>
      <Header />
      <main
        style={{
          height: "100%",
          width: "100%",
        }}
      >
        {children}
      </main>
      <React.Suspense>
        <Footer />
      </React.Suspense>
      <a
        href="https://api.whatsapp.com/send?phone=+601123234533&text=Lets Discuss Project"
        aria-label="Contact him on WhatsApp"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsApp_icon"
        title="Whatsapp chat"
      >
        <FaWhatsapp />
      </a>
    </React.Fragment>
  );
};

export default Layout;
